import './spinner.css';

const Spinner = () =>{
    return(
        <div className='container'>
            <div className='spinner'>
                <p>Loading..</p>
            </div>
        </div>
    )
}
export default Spinner